import { makeRequest } from "src/api/request";

export const sendContact = async (data: AdminAPI.LeadTool.GHL.SendContact.Request) =>
  await makeRequest.post<AdminAPI.LeadTool.GHL.SendContact.Response>(`/admin/lead-tools/ghl/send-contact/`, data);

export const leadWorkflow = async (data: AdminAPI.LeadTool.LeadWorkflow.Request) =>
  await makeRequest.post<AdminAPI.LeadTool.LeadWorkflow.Response>(`/admin/lead-tools/ghl/lead-flow/`, data);
